import { Button, Checkbox, FormControlLabel, Grid, Paper } from "@mui/material";
import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";
import Lang from "../Utils/lang";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import style from "./Dashboard.module.scss";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const lang = Lang.getInstance();

const PERSON = {
  naturalPerson: "Persoana fizica",
  legalPerson: "Persoana juridica",
};

export default function HomePage() {
  const [terms, setTerms] = useState(false);
  const notifyError = (message) => toast.error(message);
  const navigate = useNavigate();

  /**
   *
   * @param {*} event
   */
  function onChangeTerms(event) {
    setTerms(event.target.checked);
  }
  function handleContinue(state) {
    if (terms) {
      navigate("/form", { state: state });
    } else {
      notifyError(
        "Trebuie să acceptați termenii și condițiile pentru a putea completa formularul"
      );
    }
  }
  return (
    <div className={style.container}>
      <ToastContainer />
      <h1 className={style.title}>
        FORMULAR DE ÎNSCRIERE în Registrul de Evidență al Sistemelor Individuale
        Adecvate pentru Colectarea și Epurarea Apelor Uzate al Municipiului
        Suceava
      </h1>
      <Paper className={style.conditions}>
        <div style={{ textAlign: "justify" }}>
          <FormControlLabel
            control={
              <Checkbox
                style={{ color: "white" }}
                checked={terms}
                onChange={(e) => onChangeTerms(e)}
              />
            }
            label="
              Pentru completarea si transmiterea formularului de înscriere
              trebuie să acceptați termenii și condițiile"
          />
          <p>
            &nbsp;&nbsp; Prin completarea și transmiterea acestui formular
            sunteți de acord cu prelucrarea datelor cu caracter personal în
            scopul înscrierii în Registrul de Evidență a Sistemelor Individuale
            Adecvate pentru Colectarea și Epurarea Apelor Uzate al Comunei
            Scheia. Prelucrarea datelor cu caracter personal se va realiza cu
            respectarea prevederilor Regulamentului nr.679/2016 adoptat de
            Parlamentul European și Consiliul Uniunii Europene pentru aprobarea
            normelor privind protecţia în ceea ce priveşte prelucrarea datelor
            cu caracter personal, precum şi a normelor referitoare la libera
            circulaţie a acestui tip de date cu caracter personal.
          </p>
        </div>
      </Paper>
      <Grid container spacing={5}>
        <Grid item xs={12} md={6} lg={4}>
          <Paper className={style.paperPerson}>
            <p className={style.paperText}>{lang.get("naturalPerson")}</p>
            <Button
              variant="contained"
              className={style.continueButton}
              onClick={() => handleContinue(PERSON.naturalPerson)}
            >
              Continuare &nbsp;&nbsp;
              <ArrowCircleRightOutlinedIcon fontSize="medium" />
            </Button>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <Paper className={style.paperPerson}>
            <p className={style.paperText}>{lang.get("legalPerson")}</p>
            <Button
              variant="contained"
              className={style.continueButton}
              onClick={() => handleContinue(PERSON.legalPerson)}
            >
              Continuare &nbsp;&nbsp;
              <ArrowCircleRightOutlinedIcon fontSize="medium" />
            </Button>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}
